/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Payments_QInputs */

const en_platform_faq_payments_q = /** @type {(inputs: Platform_Faq_Payments_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do payments work?`)
};

const pl_platform_faq_payments_q = /** @type {(inputs: Platform_Faq_Payments_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak działają płatności?`)
};

/**
* | output |
* | --- |
* | "How do payments work?" |
*
* @param {Platform_Faq_Payments_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_payments_q = /** @type {((inputs?: Platform_Faq_Payments_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Payments_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_payments_q(inputs)
	return en_platform_faq_payments_q(inputs)
});